// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export const environment = {
  production: false,
  version: env.npm_package_version,
  serverUrl: 'http://localhost/v1', // Mock env, Ajax calls are intercepted so this value doesn't matter
  isMock: true,

  // Determines the response of mocked /v1/tenants/properties
  tenantPropertiesResponse: {
    '200': true,  // Tenant properties were returned successfully
    '404': false, // SP has disallowed signups
  },

  // Determines the response of mocked /v1/tenants/signup
  signupResponse: {
    '201': true,  // Tenant was created successfully
    '400': false, // Bad Request from form submission (unlikely as the UI validates a lot), error message from client.fake.helpers.ts (test the "Go Back" button, "contact us" = email)
    '403': false, // Rejected by the billing backend system (rejected denied party screening (DPS), error message "Thales is reviewing your request.", (no back button, cust. support = https://supportportal.thalesgroup.com/csm)
    '404': false, // Rejected by the billing backend system (very unlikely if even possible, error message "Thales is reviewing your request.", (no back button, cust. support = https://supportportal.thalesgroup.com/csm)
    '500': false, // Internal Error
    '503': false  // Unavailability
  },

  defaultLanguage: 'en-US',
  supportedLanguages: [
    'en-US',
  ],
  recaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // "test" key published by Recaptcha
};
